import React, { useContext, useMemo } from 'react';
import { useMediaQuery } from '@material-ui/core';
import bp from "./foundations/breakpoints.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaQueriesContext = /*#__PURE__*/React.createContext({
  mobile: false,
  tablet: false,
  smallerThanTablet: false,
  largerThanTablet: false,
  smallScreen: false,
  largeScreen: false
});
export function MediaQueriesProvider(_ref) {
  let {
    children
  } = _ref;
  const mobile = useMediaQuery("(max-width:".concat(bp.mobileMaxWidth, ")"));
  const tablet = useMediaQuery("(min-width:".concat(bp.tabletMinWidth, ") and (max-width: ").concat(bp.tabletMaxWidth, ")"));
  const smallerThanTablet = useMediaQuery("(max-width:".concat(bp.tabletMaxWidth, ")"));
  const largerThanTablet = useMediaQuery("(min-width:".concat(bp.desktopMinWidth, ")"));
  const smallScreen = useMediaQuery("(min-width:".concat(bp.desktopMinWidth, ") and (max-width:").concat(bp.smallScreenMaxWidth, ")"));
  const largeScreen = useMediaQuery("(min-width:".concat(bp.largeScreenMinWidth, ")"));
  const value = useMemo(() => ({
    mobile,
    tablet,
    smallerThanTablet,
    largerThanTablet,
    smallScreen,
    largeScreen
  }), [mobile, tablet, smallerThanTablet, largerThanTablet, smallScreen, largeScreen]);
  return /*#__PURE__*/_jsx(MediaQueriesContext.Provider, {
    value: value,
    children: children
  });
}
export const useMediaQueries = () => {
  return useContext(MediaQueriesContext);
};